import { Box } from '@mui/system'
import React from 'react'

import { PageSubtitle } from '@/atoms/GenericComponents'
import styled, { css, mediaQuery, muiUtils, padPx } from '@/styles'
import { ClassName } from '@/travelsuit'

interface IProps {
	className?: string
	style?: React.CSSProperties
	width?: number | string
	contentProps?: { as?: React.ElementType; ref?: React.Ref<HTMLDivElement>; style?: React.CSSProperties }
	ref?: ((ref: HTMLDivElement | null) => void) | React.Ref<HTMLDivElement>
	offsetTop?: number
	noBottomPadding?: boolean
}

const PageContentContainer = styled.div<{ noBottomPadding?: boolean }>`
	${({ noBottomPadding: $noBottomPadding }) => css`
		padding: 40px ${(p) => p.theme.spacing(3)};
		${(p) => mediaQuery.below('desktop')`
			padding: ${p.theme.spacing(3)};
			margin-top: 0;
		`}

		&& {
			${$noBottomPadding ? 'padding-bottom: 0;' : ''}
		}
	`}
`

export const PageContent = styled.div<{ width?: number | string }>`
	${({ width: $width, theme }) => css`
		max-width: ${padPx($width)};
		width: 100%;
		margin: 0 auto;

		& > ${PageSubtitle} {
			margin-bottom: ${theme.spacing(6)};

			${muiUtils.mobile} {
				margin-bottom: ${theme.spacing(4)};
			}
		}
	`}
`

const DEFAULT_MAX_WIDTH = 1024

const Page = styled(function ({
	width = DEFAULT_MAX_WIDTH,
	contentProps,
	children,
	...rest
}: React.PropsWithChildren<IProps>) {
	return (
		<PageContentContainer {...rest}>
			<PageContent width={width} {...contentProps}>
				{children}
			</PageContent>
		</PageContentContainer>
	)
})``

// Parent of Page component, should contain Tabs (optionally) and Page
// todo: refactor Page component - change its name and remove "width" prop
export const PageContainer = styled(function ({
	children,
	maxWidth,
	className,
}: {
	children: React.ReactNode
	maxWidth?: number
} & ClassName) {
	return (
		<Box
			width="100%"
			margin="0 auto"
			marginTop={{ lg: 8 }}
			maxWidth={maxWidth ?? DEFAULT_MAX_WIDTH}
			className={className}
		>
			{children}
		</Box>
	)
})`
	${Page} {
		padding: ${(p) => p.theme.spacing(8, 0)};
		${muiUtils.mobile} {
			padding: ${(p) => p.theme.spacing(4, 3, 3)};
		}
	}
`

export default Page
